import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
// import ReactJson from 'flowise-react-json-view'
// import SelectVariable from './SelectVariable'
// import { cloneDeep } from 'lodash'
// import { getAvailableNodesForVariable } from 'utils/genericHelper'
import PerfectScrollbar from 'react-perfect-scrollbar'
import robotPNG from '../../assets/images/robot.png'
import chatPNG from '../../assets/images/chathistory.png'
import { baseURL } from '../../store/constant'

// Define the shape of your Redux state
interface RootState {
    customization: any; // Replace 'any' with the actual type of customization if known
}

export const SelectVariable = ({ availableNodesForVariable, disabled = false, onSelectAndReturnVal }) => {
    const customization = useSelector((state: RootState) => state.customization)

    const onSelectOutputResponseClick = (node, prefix) => {
        const variablePath = node ? `${node.id}.data.instance` : prefix
        const newInput = `{{${variablePath}}}`
        onSelectAndReturnVal(newInput)
    }

    return (
        <>
            {!disabled && (
                <div className="flex flex-col p-4">
                    <div className="flex mb-4 ml-2 mt-2">
                        <h2 className="text-xl font-semibold">Select Variable</h2>
                    </div>
                    <PerfectScrollbar className="h-full max-h-[calc(100vh-220px)] overflow-x-hidden">
                        <div className="px-2">
                            <ul className="list-none">
                                <li className="mb-2">
                                    <button
                                        className={`w-full flex items-center p-0 rounded-lg shadow-md ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                        disabled={disabled}
                                        onClick={() => onSelectOutputResponseClick(null, 'question')}
                                    >
                                        <div className="flex items-center p-2">
                                            <div className="w-12 h-12 rounded-full bg-white overflow-hidden flex items-center justify-center">
                                                <img
                                                    className="w-full h-full p-2 object-contain"
                                                    alt='AI'
                                                    src={robotPNG}
                                                />
                                            </div>
                                            <div className="ml-2">
                                                <p className="font-medium">question</p>
                                                <p className="text-sm text-gray-600">User's question from chatbox</p>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                                <li className="mb-2">
                                    <button
                                        className={`w-full flex items-center p-0 rounded-lg shadow-md ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                        disabled={disabled}
                                        onClick={() => onSelectOutputResponseClick(null, 'chat_history')}
                                    >
                                        <div className="flex items-center p-2">
                                            <div className="w-12 h-12 rounded-full bg-white overflow-hidden flex items-center justify-center">
                                                <img
                                                    className="w-full h-full p-2 object-contain"
                                                    alt='chatHistory'
                                                    src={chatPNG}
                                                />
                                            </div>
                                            <div className="ml-2">
                                                <p className="font-medium">chat_history</p>
                                                <p className="text-sm text-gray-600">Past conversation history between user and AI</p>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                                {availableNodesForVariable && availableNodesForVariable.length > 0 &&
                                    availableNodesForVariable.map((node, index) => {
                                        const selectedOutputAnchor = node.data.outputAnchors[0].options.find(
                                            (ancr) => ancr.name === node.data.outputs['output']
                                        )
                                        return (
                                            <li className="mb-2" key={index}>
                                                <button
                                                    className={`w-full flex items-center p-0 rounded-lg shadow-md ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                                    disabled={disabled}
                                                    onClick={() => onSelectOutputResponseClick(null, node)}
                                                >
                                                    <div className="flex items-center p-2">
                                                        <div className="w-12 h-12 rounded-full bg-white overflow-hidden flex items-center justify-center">
                                                            <img
                                                                className="w-full h-full p-2 object-contain"
                                                                alt={node.data.name}
                                                                src={`${baseURL}/api/v1/node-icon/${node.data.name}`}
                                                            />
                                                        </div>
                                                        <div className="ml-2">
                                                            <p className="font-medium">{node.data.inputs.chainName ? node.data.inputs.chainName : node.data.id}</p>
                                                            <p className="text-sm text-gray-600">{`${selectedOutputAnchor?.label ?? 'output'} from ${node.data.label}`}</p>
                                                        </div>
                                                    </div>
                                                </button>
                                            </li>
                                        )
                                    })}
                            </ul>
                        </div>
                    </PerfectScrollbar>
                </div>
            )}
        </>
    )
}

SelectVariable.propTypes = {
    availableNodesForVariable: PropTypes.array,
    disabled: PropTypes.bool,
    onSelectAndReturnVal: PropTypes.func
}

export default SelectVariable
